////import { Articulo } from '../articulo/articulo.interface';

export class ArtSlider{// implements Articulo{
	id;
	idArt;
	pagina;
	slider;
	categoriaArticulo;
	fechModificado;
	usrModificado;

	constructor(
		id=false,
		idArt=false,
		pagina=false,
		categoriaArticulo=false,
		slider=false,
		fechModificado=false,
		usrModificado=false
		){
		this.id = id;
		this.idArt = idArt;
		this.pagina = pagina;
		this.categoriaArticulo = categoriaArticulo;
		this.fechModificado = fechModificado;
		this.usrModificado = usrModificado;
		this.slider = slider;
	}

	setCategoriaArticulo(categoriaArticulo){
		this.categoriaArticulo = categoriaArticulo;
	}
}
